import { TableHeader } from '@/components/ui/table';

export function CoverageStatusHeader() {
  return (
    <TableHeader narrow className="text-left align-bottom">
      Coverage Status
    </TableHeader>
  );
}
